import { verify } from "@/api/launcherApp/signup"
import type { TApiSignupVerifyParams, TApiSignupVerifyResponse, TSignupVerifyErrorCode, TSignupVerifyErrorField } from "@/api/launcherApp/signup/schema"
import { createScopedLogger } from "@/lib/observability"

const logger = createScopedLogger("signup", {
  action: "verify",
})

export async function actionVerifySignup(params: TApiSignupVerifyParams): Promise<{ success: boolean; data?: TApiSignupVerifyResponse }> {
  try {
    const result = await verify(params)
    return { success: true, data: result }
  } catch (error) {
    await logger.error("signup.verify.action_failed", error)
    return { success: false }
  }
}

export async function actionValidateSignupEmail(email: string): Promise<{ success: boolean; error?: { code: TSignupVerifyErrorCode; field: TSignupVerifyErrorField; message: string; rejectedValue: string } }> {
  try {
    const result = await verify({
      firstName: "Jane",
      lastName: "Doe",
      email,
      phoneNumber: "+14155550117",
      companyName: "Acme",
      smsOptIn: true,
      emailMarketingOptIn: true,
      trialType: "solo",
      passwd: "Password123!",
    })

    const emailError = result.errors?.find((error) => error.field === "email")
    if (!result.success) {
      return {
        success: false,
        error: {
          code: emailError?.code ?? "validator.invalid",
          field: "email",
          message: emailError?.defaultMessage ?? "We could not validate this email. Please try again.",
          rejectedValue: String(emailError?.rejectedValue ?? email),
        },
      }
    }

    return { success: true }
  } catch (error) {
    await logger.error("signup.email_validation.action_failed", error)
    return {
      success: false,
      error: {
        code: "validator.invalid",
        field: "email",
        message: "We could not validate this email. Please try again.",
        rejectedValue: email,
      },
    }
  }
}
